import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=68667fec&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=68667fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68667fec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68667fec')) {
      api.createRecord('68667fec', component.options)
    } else {
      api.reload('68667fec', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=68667fec&scoped=true&", function () {
      api.rerender('68667fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dxNmz1L7zVeM/JS/comp/PopupDialog.vue"
export default component.exports